var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tls-popup-display",
      attrs: { "data-tls-component": "popup" }
    },
    [
      _c("div", { staticClass: "tls-popup-display--shadow-layer" }),
      _vm._v(" "),
      _c("div", { staticClass: "tls-popup-display--container" }, [
        _c("div", { staticClass: "tls-popup-display--content" }, [
          _c("div", { staticClass: "tls-popup" }, [
            _c("div", { staticClass: "tls-popup--header" }, [
              _c("div", { staticClass: "tls-popup-header" }, [
                _c("div", { staticClass: "tls-popup-header--logo" }, [
                  _c("a", { staticClass: "tls-logo" }, [
                    _c("img", {
                      staticClass: "tls-logo--img",
                      attrs: {
                        alt: "logo",
                        src: _vm.MINIO_BUCKET_ADDRESS + "/logo.svg"
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tls-popup-header--action" }, [
                  _c(
                    "button",
                    {
                      staticClass: "tls-button-icon",
                      on: { click: _vm.close }
                    },
                    [_vm._v("×")]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tls-popup--body" },
              [
                _c(
                  "div",
                  { staticClass: "tls-popup--body-slot tls-popup-title" },
                  [
                    _c("h2", { staticClass: "tls-heading-2" }, [
                      _vm._v(_vm._s(_vm.popupTitle))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  _vm.popupComponentName,
                  _vm._b(
                    {
                      tag: "component",
                      on: {
                        input: function(prop) {
                          return _vm.$emit("component-action", prop)
                        }
                      }
                    },
                    "component",
                    _vm.popupData,
                    false
                  )
                ),
                _vm._v(" "),
                _vm.showSecondComponent
                  ? _c(
                      _vm.popupComponentName,
                      _vm._b(
                        { tag: "component" },
                        "component",
                        _vm.popupDataLanguageAlert,
                        false
                      )
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasCancelAction || _vm.hasConfirmAction
                  ? _c("div", { staticClass: "tls-popup--body-slot" }, [
                      _c("div", { staticClass: "tls-popup-action" }, [
                        _vm.hasCancelAction
                          ? _c(
                              "button",
                              {
                                staticClass: "tls-button-danger -uppercase",
                                class: _vm.hasConfirmAction
                                  ? "tls-button-danger"
                                  : "tls-button-primary",
                                on: { click: _vm.close }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.hasConfirmAction
                                        ? _vm._.get(_vm.keywords, "cancel")
                                        : _vm._.get(_vm.keywords, "back")
                                    ) +
                                    "\n                            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasConfirmAction
                          ? _c(
                              "button",
                              {
                                staticClass: "tls-button-primary -uppercase",
                                attrs: { "data-tls-value": "confirm" },
                                on: { click: _vm.confirm }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm._.get(_vm.keywords, "confirm")) +
                                    "\n                            "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }